var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messages && _vm.messages.length > 0)?_c('div',{staticClass:"row over-content"},[_c('div',{staticClass:"fourteen wide column"},[_c('ul',{staticClass:"message-list",attrs:{"aria-live":"assertive"}},_vm._l((_vm.messages),function(message){return _c('MessageInfo',{key:'message-' + message.counter,attrs:{"message":message}})}),1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }